var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 711,
    height: 645,
    viewBox: "0 0 711 645",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.656 467.382L227.7 515.986C232.446 518.729 240.152 518.729 244.907 515.986L328.951 467.391C333.697 464.649 333.697 460.194 328.951 457.451L244.983 408.951C240.227 406.208 232.522 406.208 227.775 408.941L143.675 457.442C138.91 460.184 138.91 464.63 143.656 467.382Z",
    fill: "url(#paint0_linear_431_11178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368.642 341.147L498.608 416.3C505.954 420.546 517.867 420.546 525.213 416.3L655.179 341.147C662.525 336.901 662.525 330.015 655.179 325.769L525.327 250.777C517.981 246.53 506.058 246.53 498.712 250.767L368.661 325.769C361.296 330.015 361.296 336.901 368.642 341.147Z",
    fill: "url(#paint1_linear_431_11178)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.282 321.352L262.644 367.97C267.58 370.609 275.588 370.609 280.533 367.97L367.895 321.352C372.83 318.713 372.83 314.447 367.895 311.809L280.609 265.285C275.673 262.656 267.655 262.646 262.72 265.276L175.301 311.799C170.347 314.447 170.347 318.722 175.282 321.352Z",
    fill: "url(#paint2_linear_431_11178)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.943 90.2002L245.512 118.64C223.01 89.226 177.542 94.9764 142.739 132.165C109.883 167.292 97.9798 218.109 113.628 250.578L85.2064 279.009C84.9701 278.564 84.7431 278.129 84.5351 277.675C84.3082 277.221 84.0908 276.776 83.8828 276.323C83.2304 274.97 82.6158 273.589 82.0485 272.189C81.6609 271.253 81.3016 270.307 80.9423 269.371C80.7627 268.889 80.5925 268.416 80.4129 267.933C80.2427 267.46 80.0819 266.978 79.9212 266.496C79.6848 265.834 79.4674 265.172 79.2688 264.51C79.127 264.046 78.9757 263.573 78.8528 263.11C78.7488 262.76 78.6448 262.41 78.5503 262.069C78.4084 261.587 78.2855 261.105 78.1437 260.622C78.1342 260.594 78.1248 260.547 78.1153 260.518C78.0019 260.036 77.8695 259.554 77.7466 259.071C77.2077 256.972 76.7444 254.844 76.3473 252.687C76.2622 252.243 76.1866 251.817 76.1109 251.382C75.9975 250.729 75.884 250.077 75.7895 249.415C75.6476 248.592 75.5342 247.75 75.4207 246.899C75.3356 246.275 75.2505 245.641 75.1844 245.017C75.1276 244.563 75.0804 244.109 75.0236 243.645C74.844 241.886 74.6927 240.108 74.5792 238.311C74.532 237.649 74.5036 236.978 74.4752 236.316C74.4658 236.145 74.4563 235.975 74.4563 235.805C74.428 234.963 74.3902 234.131 74.3712 233.289C74.3618 232.826 74.3618 232.362 74.3523 231.908C73.8512 190.861 92.1084 143.496 125.692 107.593C151.541 79.9572 181.522 64.4841 208.856 61.9021C213.877 61.4292 218.812 61.3913 223.615 61.798C225.109 61.9115 226.584 62.0912 228.049 62.2899C230.252 62.602 232.417 63.0087 234.535 63.5194C237.438 64.1909 240.274 65.061 243.035 66.1014L243.092 66.1203L243.338 66.2149C255.27 70.7925 265.764 78.7561 273.943 90.2002Z",
    fill: "#F3F6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.511 312.187L119.537 311.79C118.998 311.563 118.469 311.326 117.93 311.08L120.511 312.187Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.035 66.092C240.275 65.0516 237.448 64.1815 234.536 63.5099C232.408 62.9992 230.243 62.5831 228.05 62.2804C226.594 62.0723 225.109 61.9021 223.615 61.7886C218.812 61.3819 213.877 61.4197 208.856 61.8926C181.523 64.4747 151.551 79.9573 125.692 107.584C92.0992 143.477 73.842 190.851 74.3526 231.899C74.3526 232.362 74.362 232.826 74.3715 233.28C74.3904 234.121 74.4282 234.954 74.4566 235.795C74.4566 235.966 74.466 236.136 74.4755 236.306C74.5038 236.968 74.5417 237.64 74.5795 238.302C74.6835 240.089 74.8348 241.877 75.0239 243.636C75.0806 244.099 75.1184 244.544 75.1846 245.007C75.2508 245.632 75.3359 246.265 75.421 246.89C75.525 247.741 75.6479 248.573 75.7897 249.405C75.8843 250.058 75.9977 250.711 76.1112 251.373C76.1868 251.817 76.2624 252.252 76.3475 252.678C76.7446 254.834 77.2079 256.962 77.7468 259.062C77.8603 259.544 77.9832 260.027 78.1156 260.509C78.125 260.537 78.1345 260.585 78.1439 260.613C78.2763 261.095 78.4087 261.578 78.5505 262.06C78.645 262.4 78.7396 262.75 78.8531 263.1C78.9949 263.564 79.1272 264.037 79.2691 264.5C79.4771 265.162 79.6851 265.824 79.9214 266.486C80.0727 266.969 80.2429 267.451 80.4131 267.924C80.5833 268.406 80.7535 268.889 80.9426 269.362C81.2829 270.317 81.6611 271.253 82.0488 272.18C82.6161 273.58 83.2306 274.961 83.883 276.313C84.091 276.767 84.3085 277.221 84.5354 277.666C84.7528 278.12 84.9798 278.555 85.2067 278.999L59.6315 260.178H59.622C57.6554 254.91 56.1427 249.367 55.0743 243.617C46.65 198.635 64.9545 140.63 104.409 98.4664C130.259 70.8304 160.24 55.3572 187.574 52.7752C194.154 52.151 200.583 52.2834 206.767 53.163C211.976 53.9007 216.997 55.1775 221.809 57.0029L222.055 57.0975C222.717 57.3528 223.388 57.6271 224.041 57.9014L224.712 58.1946L243.035 66.092Z",
    fill: "url(#paint3_linear_431_11178)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M286.376 116.408L256.943 145.86L237.693 134.671L267.854 105.144L286.376 116.408Z",
    fill: "url(#paint4_linear_431_11178)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.189 175.057C254.939 191.854 248.585 209.361 238.629 225.439C233.959 232.958 228.532 240.108 222.32 246.738C192.849 278.224 155.815 287.161 131.478 271.357L113.278 261.105C229.789 273.703 237.703 134.662 237.703 134.662L256.953 145.851C258.56 155.006 258.617 164.899 257.189 175.057Z",
    fill: "url(#paint5_linear_431_11178)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M289.213 168.89C285.998 192.875 276.922 217.91 262.692 240.884C256.017 251.628 248.264 261.833 239.396 271.31C210.36 302.341 176.162 318.041 146.332 317.389H146.323C137.237 317.181 128.538 315.459 120.521 312.187L117.939 311.08C114.961 309.718 112.068 308.12 109.307 306.285C108.418 305.708 107.539 305.093 106.669 304.46C105.09 303.315 103.568 302.086 102.074 300.79L131.488 271.367C155.825 287.171 192.859 278.233 222.33 246.748C228.541 240.118 233.969 232.967 238.639 225.448C248.595 209.37 254.949 191.863 257.199 175.066C258.627 164.899 258.57 155.006 256.953 145.869L286.386 116.427C290.971 132.316 291.813 150.296 289.213 168.89Z",
    fill: "#F3F6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.478 271.367L102.065 300.79L83.1644 289.025C83.155 289.015 83.1455 289.006 83.1455 289.006L113.278 261.114L131.478 271.367Z",
    fill: "url(#paint6_linear_431_11178)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.313 317.389C110.139 319.574 83.9395 289.914 83.1548 289.025L102.055 300.79C103.549 302.086 105.071 303.316 106.65 304.46C107.52 305.094 108.399 305.708 109.288 306.285C112.058 308.12 114.942 309.719 117.92 311.08C118.459 311.326 118.988 311.563 119.527 311.79L120.501 312.187C128.528 315.459 137.227 317.181 146.313 317.389Z",
    fill: "url(#paint7_linear_431_11178)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.813 233.195C124.718 233.195 124.614 233.185 124.51 233.157C123.943 232.996 123.612 232.4 123.773 231.833L142.332 167.509L178.09 219.131L196.31 134.927L214.312 186.926L222.414 154.183C222.556 153.606 223.142 153.256 223.71 153.398C224.286 153.54 224.636 154.126 224.494 154.694L214.652 194.474L196.782 142.862L179.13 224.418L143.126 172.446L125.824 232.428C125.711 232.892 125.285 233.195 124.813 233.195Z",
    fill: "url(#paint8_linear_431_11178)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.285 225.222C129.975 226.215 130.193 227.577 129.994 229.005C129.833 230.168 129.398 231.388 128.708 232.504C128.387 233.024 128.009 233.526 127.574 233.98C125.106 236.618 121.863 236.978 120.341 234.774C118.819 232.58 119.584 228.664 122.052 226.025C124.52 223.387 127.763 223.027 129.285 225.222Z",
    fill: "url(#paint9_linear_431_11178)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.268 165.466C147.958 166.459 148.176 167.821 147.977 169.25C147.816 170.413 147.381 171.633 146.691 172.749C146.37 173.269 145.991 173.77 145.557 174.224C143.089 176.863 139.846 177.223 138.324 175.019C136.801 172.825 137.567 168.909 140.035 166.27C142.503 163.632 145.746 163.272 147.268 165.466Z",
    fill: "url(#paint10_linear_431_11178)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183.168 215.65C183.858 216.643 184.075 218.005 183.877 219.433C183.716 220.597 183.281 221.817 182.591 222.933C182.27 223.453 181.891 223.954 181.456 224.408C178.989 227.047 175.746 227.406 174.224 225.212C172.701 223.018 173.467 219.102 175.935 216.463C178.403 213.815 181.646 213.456 183.168 215.65Z",
    fill: "url(#paint11_linear_431_11178)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.179 134.104C201.869 135.097 202.087 136.459 201.888 137.887C201.727 139.05 201.292 140.27 200.602 141.387C200.281 141.907 199.903 142.408 199.468 142.862C197 145.501 193.757 145.86 192.235 143.666C190.713 141.472 191.478 137.556 193.946 134.917C196.414 132.269 199.657 131.91 201.179 134.104Z",
    fill: "url(#paint12_linear_431_11178)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.946 149.672C228.636 150.665 228.853 152.027 228.655 153.455C228.494 154.618 228.059 155.838 227.369 156.954C227.047 157.474 226.669 157.976 226.234 158.43C223.767 161.068 220.524 161.428 219.001 159.234C217.479 157.039 218.245 153.124 220.713 150.485C223.18 147.837 226.414 147.477 227.946 149.672Z",
    fill: "url(#paint13_linear_431_11178)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1896 128.76L43.1991 135.674C43.1991 136.572 42.7169 137.414 41.9416 137.859L27.5136 146.191C26.5114 146.768 25.2539 146.049 25.2539 144.886V138.682C25.2539 137.726 25.7645 136.847 26.587 136.364L41.4689 127.767C42.2347 127.323 43.1896 127.871 43.1896 128.76Z",
    fill: "url(#paint14_linear_431_11178)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66404 171.671C1.2953 171.671 0.936019 171.482 0.737469 171.132C0.44437 170.621 0.614556 169.959 1.12511 169.666L42.66 145.661C43.1706 145.359 43.8324 145.538 44.1255 146.049C44.4186 146.56 44.2484 147.222 43.7378 147.515L2.20296 171.519C2.03277 171.623 1.85313 171.671 1.66404 171.671Z",
    fill: "url(#paint15_linear_431_11178)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66413 182.358C1.30484 182.358 0.945562 182.169 0.747012 181.838C0.444459 181.327 0.60519 180.675 1.10629 180.363L42.6412 155.271C43.1517 154.959 43.8041 155.129 44.1161 155.63C44.4187 156.141 44.2579 156.793 43.7568 157.106L2.22196 182.197C2.05177 182.301 1.85322 182.358 1.66413 182.358Z",
    fill: "url(#paint16_linear_431_11178)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M328.639 150.353L328.648 157.266C328.648 158.165 328.166 159.007 327.391 159.451L312.963 167.783C311.961 168.36 310.703 167.642 310.703 166.478V160.274C310.703 159.319 311.214 158.439 312.036 157.957L326.918 149.359C327.684 148.924 328.639 149.473 328.639 150.353Z",
    fill: "url(#paint17_linear_431_11178)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M312.585 177.885C312.216 177.885 311.857 177.695 311.658 177.346C311.365 176.835 311.535 176.173 312.046 175.88L353.581 151.875C354.091 151.573 354.753 151.752 355.046 152.263C355.34 152.774 355.169 153.436 354.649 153.729L313.114 177.733C312.944 177.837 312.765 177.885 312.585 177.885Z",
    fill: "url(#paint18_linear_431_11178)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M312.585 188.572C312.226 188.572 311.866 188.383 311.668 188.052C311.365 187.541 311.526 186.889 312.027 186.576L353.562 161.485C354.073 161.172 354.725 161.343 355.037 161.844C355.34 162.355 355.179 163.007 354.668 163.319L313.133 188.411C312.963 188.515 312.774 188.572 312.585 188.572Z",
    fill: "url(#paint19_linear_431_11178)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M272.26 65.4867L272.27 76.3161C272.27 77.7347 271.513 79.0399 270.294 79.7493L247.687 92.8107C246.108 93.7186 244.142 92.5837 244.142 90.7583V81.0356C244.142 79.5412 244.945 78.1509 246.241 77.4037L269.566 63.9356C270.766 63.2358 272.26 64.1059 272.26 65.4867Z",
    fill: "url(#paint20_linear_431_11178)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M166.206 302.54L166.215 313.369C166.215 314.788 165.459 316.093 164.239 316.802L141.633 329.864C140.054 330.772 138.087 329.637 138.087 327.811V318.089C138.087 316.594 138.891 315.204 140.186 314.457L163.511 300.989C164.712 300.289 166.206 301.15 166.206 302.54Z",
    fill: "url(#paint21_linear_431_11178)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7689 183.077L87.7784 193.906C87.7784 195.325 87.022 196.63 85.8023 197.339L63.1959 210.401C61.617 211.309 59.6504 210.174 59.6504 208.348V198.626C59.6504 197.131 60.454 195.741 61.7494 194.994L85.0743 181.526C86.2656 180.835 87.7595 181.696 87.7689 183.077Z",
    fill: "url(#paint22_linear_431_11178)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M276.089 233.923L276.099 244.752C276.099 246.171 275.342 247.476 274.123 248.185L251.516 261.247C249.937 262.155 247.971 261.02 247.971 259.194V249.471C247.971 247.977 248.774 246.587 250.07 245.84L273.395 232.372C274.586 231.672 276.089 232.542 276.089 233.923Z",
    fill: "url(#paint23_linear_431_11178)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M169.751 65.4867L169.761 76.3161C169.761 77.7347 169.004 79.0399 167.785 79.7493L145.178 92.8107C143.599 93.7186 141.633 92.5837 141.633 90.7583V81.0356C141.633 79.5412 142.436 78.1509 143.732 77.4037L167.057 63.9356C168.257 63.2358 169.751 64.1059 169.751 65.4867Z",
    fill: "url(#paint24_linear_431_11178)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M480.152 5.97747C481.381 5.2303 482.894 4.9371 484.378 5.2965C484.898 5.41945 485.418 5.61807 485.919 5.91126L488.198 7.23537L697.432 128.108C701.082 130.217 703.332 134.123 703.332 138.341V285.128C703.332 286.074 703.153 286.963 702.85 287.757C702.415 288.883 701.706 289.838 700.836 290.585L706.585 286.792L706.622 286.764C708.703 285.544 710.187 283.302 710.187 280.541V133.754C710.187 129.536 707.937 125.63 704.287 123.52L492.765 1.32418C490.628 0.0946464 488.179 0.435131 486.468 1.7687L480.152 5.97747Z",
    fill: "url(#paint25_linear_431_11178)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M477.419 159.215C477.419 164.104 480.019 168.616 484.246 171.056L692.544 291.351C695.381 292.997 698.652 292.448 700.836 290.585C701.706 289.838 702.415 288.873 702.85 287.757C703.152 286.963 703.332 286.074 703.332 285.128V138.341C703.332 134.123 701.082 130.217 697.432 128.108L488.198 7.23543L485.919 5.91132C485.418 5.61813 484.898 5.41951 484.378 5.29656C482.894 4.93716 481.381 5.23035 480.152 5.97753L480.057 6.04373C479.291 6.53554 478.639 7.20706 478.176 8.01098C477.713 8.8149 477.438 9.75124 477.438 10.7916L477.419 159.215Z",
    fill: "#F3F6FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M639.55 136.894V182.169L678.599 190.795C677.313 177.308 670.893 162.657 660.19 151.232C653.751 144.347 646.604 139.533 639.55 136.894Z",
    fill: "url(#paint26_linear_431_11178)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M639.55 225.051V182.169L612.585 202.92C614.476 205.634 616.575 208.235 618.882 210.703C625.33 217.598 632.497 222.403 639.55 225.051Z",
    fill: "url(#paint27_linear_431_11178)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M600.785 173.487C600.871 174.168 600.975 174.839 601.097 175.53L639.55 182.169L612.538 138.767C610.108 140.431 607.952 142.578 606.108 145.217C600.937 152.689 599.292 162.809 600.785 173.487Z",
    fill: "url(#paint28_linear_431_11178)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M612.538 138.767L639.55 182.169V136.894C629.651 133.168 619.903 133.716 612.538 138.767Z",
    fill: "url(#paint29_linear_431_11178)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M639.55 182.169V225.051C652.711 229.969 665.551 227.368 672.973 216.681C677.767 209.777 679.535 200.584 678.589 190.795L639.55 182.169Z",
    fill: "#A4C9FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M601.098 175.53C602.478 183.616 605.655 191.948 610.42 199.638C611.101 200.754 611.819 201.841 612.585 202.91L639.55 182.16L601.098 175.53Z",
    fill: "url(#paint30_linear_431_11178)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M580.108 87.5425L580.089 102.183C580.089 104.671 577.395 106.212 575.248 104.973L500.858 61.9872C499.052 60.9469 497.937 59.0175 497.937 56.9273V40.7448C497.937 38.9005 499.931 37.7466 501.529 38.6735L577.092 82.3123C578.955 83.3905 580.108 85.3861 580.108 87.5425Z",
    fill: "url(#paint31_linear_431_11178)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M580.089 125.1V193.518C580.089 197.254 576.052 199.609 572.809 197.756L502.484 157.805C499.667 156.207 497.917 153.209 497.917 149.965V78.5197C497.917 75.7107 500.962 73.9515 503.392 75.3607L575.371 116.928C578.293 118.612 580.089 121.733 580.089 125.1Z",
    fill: "url(#paint32_linear_431_11178)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M559.544 132.279C559.411 132.279 559.27 132.241 559.137 132.175L518.075 108.482C517.687 108.255 517.555 107.764 517.782 107.385C518.009 106.998 518.5 106.865 518.888 107.092L559.95 130.784C560.338 131.011 560.47 131.503 560.243 131.881C560.092 132.137 559.818 132.279 559.544 132.279Z",
    fill: "url(#paint33_linear_431_11178)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M569.821 150.107C569.689 150.107 569.547 150.069 569.415 150.003L507.798 114.413C507.41 114.186 507.278 113.694 507.505 113.306C507.722 112.918 508.223 112.786 508.611 113.013L570.228 148.603C570.615 148.83 570.748 149.322 570.521 149.709C570.379 149.955 570.105 150.107 569.821 150.107Z",
    fill: "url(#paint34_linear_431_11178)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M569.821 161.957C569.689 161.957 569.547 161.92 569.415 161.853L507.788 126.263C507.401 126.036 507.268 125.544 507.495 125.157C507.722 124.769 508.214 124.636 508.601 124.863L570.228 160.454C570.615 160.681 570.748 161.172 570.521 161.56C570.379 161.806 570.105 161.957 569.821 161.957Z",
    fill: "url(#paint35_linear_431_11178)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M569.821 173.827C569.689 173.827 569.547 173.789 569.415 173.723L506.408 137.338C506.02 137.111 505.888 136.62 506.115 136.232C506.342 135.844 506.833 135.712 507.221 135.939L570.228 172.323C570.615 172.55 570.748 173.042 570.521 173.43C570.379 173.685 570.105 173.827 569.821 173.827Z",
    fill: "url(#paint36_linear_431_11178)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M672.954 352.516L675.356 351.125L637.395 285.374L599.992 306.976L553.417 247.816L525.79 263.772L507.59 221.769L479.263 205.379L477.874 207.781L505.406 223.718L524.486 267.725L552.727 251.41L599.301 310.579L636.383 289.157L672.954 352.516Z",
    fill: "#F3F6FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 196.583V218.1L470.631 201.955L479.953 196.583Z",
    fill: "#F3F6FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M278.378 350.425L277.243 351.608L274.86 347.739C274.86 347.739 275.106 344.193 275.825 338.594C276.543 332.994 276.165 326.847 276.165 326.847L278.066 323.631C278.264 325.655 278.359 327.849 278.226 330.611C277.895 337.402 277.489 340.362 277.82 345.791C277.924 347.399 278.132 348.988 278.378 350.425Z",
    fill: "url(#paint37_linear_431_11178)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M301.125 423.166C301.125 423.166 302.298 426.032 302.033 429.286C301.768 432.539 299.197 430.865 292.228 429.333C287.671 428.33 283.937 427.252 284.504 425.777C285.071 424.301 294.819 422.882 294.819 422.882L297.911 422.561L301.125 423.166Z",
    fill: "#012860"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M292.427 431.754C292.427 431.754 293.619 434.658 293.354 437.968C293.089 441.269 290.48 439.566 283.398 438.015C278.775 436.994 274.983 435.906 275.56 434.402C276.137 432.898 286.027 431.461 286.027 431.461L289.165 431.13L292.427 431.754Z",
    fill: "#012860"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M308.538 344.779C308.538 344.779 308.878 352.184 306.448 355.778C304.019 359.363 301.371 373.228 301.125 386.923C300.88 400.618 301.125 423.166 301.125 423.166C301.125 423.166 299.509 424.15 297.599 423.923C295.689 423.696 294.819 422.882 294.819 422.882L289.42 348.136L291.642 341.781L308.538 344.779Z",
    fill: "url(#paint38_linear_431_11178)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M299.944 352.213C299.944 352.213 300.294 359.732 297.826 363.373C295.358 367.015 292.673 381.079 292.427 394.982C292.181 408.885 292.427 431.754 292.427 431.754C292.427 431.754 290.782 432.757 288.844 432.52C286.906 432.284 286.026 431.461 286.026 431.461L280.542 355.618L282.793 349.167L299.944 352.213Z",
    fill: "#F3F6FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M282.197 292.581C280.58 294.104 280.353 296.326 280.353 296.326C280.353 296.326 279.389 297.688 278.85 297.603C278.321 297.527 274.567 295.853 274.567 295.853C274.567 295.853 275.683 294.018 274.775 292.912C273.867 291.796 274.283 290.812 274.605 290.141C274.794 289.762 275.569 288.939 276.439 288.192C277.545 287.246 278.784 286.443 279.011 286.934C279.427 287.795 277.394 290.112 277.848 290.141H277.857C277.867 290.141 277.867 290.141 277.867 290.141C279.143 290.15 281.271 290.065 283.445 289.507C283.455 289.507 283.814 291.058 282.197 292.581Z",
    fill: "url(#paint39_linear_431_11178)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M275.097 325.702C275.097 325.702 272.884 321.371 272.799 309.425C272.714 297.48 272.799 296.326 272.799 296.326C272.799 296.326 274.756 295.588 276.846 295.664C278.935 295.749 280.968 296.525 280.968 296.525L280.524 304.848L275.097 325.702Z",
    fill: "url(#paint40_linear_431_11178)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M284.145 289.318C284.145 289.318 284.457 292.836 284.145 295.011C283.833 297.196 287.416 298.965 287.539 298.88C287.662 298.795 292.03 294.312 292.03 294.312L290.981 287.71C290.981 287.71 290.848 286.613 290.536 286.49C290.215 286.367 285.79 285.629 285.79 285.629L284.145 289.318Z",
    fill: "url(#paint41_linear_431_11178)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M289.846 285.317C288.466 287.663 285.932 288.883 283.455 289.497C281.28 290.055 279.153 290.141 277.876 290.131C277.867 290.131 277.867 290.131 277.867 290.131H277.857C277.394 290.103 279.436 287.795 279.02 286.925C278.793 286.433 277.555 287.237 276.449 288.183C276.354 286.887 276.326 285.09 276.676 283.236C277.337 279.746 278.047 277.94 278.047 277.94L283.54 274.535C283.53 274.554 293.136 279.718 289.846 285.317Z",
    fill: "url(#paint42_linear_431_11178)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M308.567 345.29C308.567 345.29 307.356 349.678 300.331 353.197C293.297 356.705 279.739 356.384 279.739 356.384C279.739 356.384 278.945 353.83 278.368 350.425C278.122 348.988 277.914 347.399 277.81 345.782C277.479 340.343 277.886 337.383 278.217 330.602C278.359 327.84 278.255 325.646 278.056 323.622C277.763 320.671 277.243 318.089 276.893 314.608C276.316 308.763 279.446 299.618 281.422 297.225C283.398 294.832 289.364 292.647 289.364 292.647C289.364 292.647 293.609 291.673 297.013 291.947C298.393 292.061 299.528 292.94 300.379 294.472C300.379 294.472 300.388 294.501 300.417 294.548C300.53 294.756 300.634 294.964 300.729 295.191C300.738 295.22 300.747 295.248 300.766 295.276C301.627 297.281 302.1 300.147 302.081 303.722C302.081 304.233 302.071 304.753 302.052 305.292C301.825 310.806 303.073 316.065 304.548 321.219C305.248 323.66 305.995 326.071 306.666 328.474C308.784 335.955 308.567 345.29 308.567 345.29Z",
    fill: "url(#paint43_linear_431_11178)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M287 301.386C285.989 298.918 282.888 298.066 280.836 299.778C279.616 300.79 278.33 302.549 277.252 305.585C274.199 314.154 272.837 325.097 276.165 326.837C283.086 330.46 285.885 315.223 287.369 308.3C288.031 305.226 287.643 302.956 287 301.386Z",
    fill: "url(#paint44_linear_431_11178)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M304.586 321.229C303.111 316.084 301.863 310.816 302.09 305.302C302.26 300.998 301.797 297.584 300.804 295.295C302.137 298.114 306.496 307.534 307.366 313.133C307.848 316.273 306.326 319.11 304.586 321.229Z",
    fill: "url(#paint45_linear_431_11178)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M308.566 345.29C308.566 345.29 307.356 349.678 300.331 353.197C306.865 347.049 304.671 336.607 296.256 335.293C287.851 333.978 296.663 326.554 299.726 324.151C302.79 321.749 299.556 315.857 294.952 315.686C290.347 315.526 302.118 303.741 302.118 303.741C302.118 304.252 302.109 304.772 302.09 305.311C301.863 310.825 303.111 316.084 304.586 321.238C305.286 323.678 306.033 326.09 306.704 328.492C308.784 335.955 308.566 345.29 308.566 345.29Z",
    fill: "url(#paint46_linear_431_11178)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M275.513 269.059C275.513 269.059 274.246 274.828 278.037 277.959C281.829 281.089 281.848 281.524 282.188 282.905C282.538 284.277 281.819 285.648 281.819 285.648C281.819 285.648 284.675 282.631 285.44 283.615C286.206 284.608 284.277 287.511 286.944 288.117C289.61 288.722 293.94 287.057 295.311 284.097C296.682 281.127 296.153 278.347 296.153 278.347C296.153 278.347 296.493 272.908 293.364 270.657C291.075 269.012 290.584 270.383 288.721 269.352C288.088 269.002 288.655 266.921 286.263 266.921C284.448 266.921 283.682 269.012 281.592 268.019C279.9 267.215 282.15 264.907 279.843 263.867C277.555 262.826 275.513 269.059 275.513 269.059Z",
    fill: "#012860"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M466.566 403.815C466.566 403.815 463.89 412.384 468.712 411.94C473.534 411.495 483.792 405.962 483.348 403.815C482.903 401.668 471.983 403.579 471.983 403.579L468.532 402.302L466.566 403.815Z",
    fill: "url(#paint47_linear_431_11178)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M454.199 400.864C454.199 400.864 451.551 409.348 456.317 408.913C461.091 408.469 471.255 402.992 470.811 400.864C470.366 398.746 459.56 400.628 459.56 400.628L456.146 399.361L454.199 400.864Z",
    fill: "url(#paint48_linear_431_11178)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M460.42 350.917C460.42 350.917 463.096 360.129 462.793 365.624C462.491 371.119 466.471 404.997 466.471 404.997C466.471 404.997 466.934 405.764 468.56 405.66C470.187 405.556 471.113 404.789 471.113 404.789C471.113 404.789 471.633 350.879 470.3 347.191C468.967 343.493 460.42 345.148 460.42 345.148V350.917Z",
    fill: "url(#paint49_linear_431_11178)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M448.393 348.903C448.393 348.903 451.05 358.029 450.738 363.468C450.435 368.906 454.378 402.453 454.378 402.453C454.378 402.453 454.832 403.21 456.449 403.115C458.065 403.011 458.983 402.255 458.983 402.255C458.983 402.255 459.493 348.874 458.169 345.214C456.846 341.554 448.384 343.199 448.384 343.199V348.903H448.393Z",
    fill: "url(#paint50_linear_431_11178)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M477.278 350.756C477.278 350.756 473.439 348.997 470.537 349.082C464.173 349.271 464.864 350.983 458.122 351.314C451.476 351.636 444.64 347.039 444.64 347.039C444.668 346.169 442.957 343.247 444.564 337.496C446.058 332.153 445.396 330.185 444.716 327.537C445.916 326.26 447.902 324.984 450.927 325.617C456.354 326.762 466.046 323.868 466.046 323.868L466.036 323.858C462.68 324.53 458.699 324.757 454.52 323.782C453.244 323.48 452.09 323.177 451.05 322.874C447.637 321.881 445.5 320.898 444.186 320.094C444.186 320.094 445.888 319.952 448.441 319.744C451.608 319.489 456.08 319.139 460.24 318.845C465.866 318.439 470.915 318.127 471.378 318.287C472.446 318.666 474.29 321.077 474.29 321.077L477.278 350.756Z",
    fill: "url(#paint51_linear_431_11178)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M445.132 269.73C445.132 269.73 437.36 284.059 437.823 289.961C438.286 295.872 453.376 298.501 453.376 298.501L452.686 283.255L445.132 269.73Z",
    fill: "url(#paint52_linear_431_11178)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M466.83 246.672C466.83 246.672 469.61 250.815 468.939 252.29C468.608 253.018 471.633 257.095 469.638 258.476C466.915 260.367 462.746 260.112 458.349 256.584C453.953 253.056 456.714 246.672 456.714 246.672L461.261 242.889L466.83 246.672Z",
    fill: "url(#paint53_linear_431_11178)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M489.068 262.977C489.068 262.977 493.304 251.439 494.032 252.167C494.76 252.895 493.143 256.584 494.448 258.097C495.752 259.61 497.492 260.31 495.781 262.457C494.069 264.604 489.427 267.148 489.427 267.148L489.068 262.977Z",
    fill: "url(#paint54_linear_431_11178)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M479.774 291.739C473.789 288.684 471.52 284.579 471.245 284.059C471.425 284.485 472.579 287.332 471.964 288.75C471.765 289.214 471.463 289.63 471.17 290.056C471.17 290.056 471.141 290.093 471.104 290.15C471.075 290.188 471.047 290.226 471.019 290.264C471 290.292 470.971 290.32 470.952 290.358C470.347 291.247 469.865 292.231 470.328 293.801C470.773 295.305 471.614 296.827 472.484 299.419C472.494 299.428 472.493 299.428 472.493 299.428C473.08 301.169 473.666 303.391 474.158 306.427C475.368 313.956 475.528 320.397 475.528 320.397C475.528 320.397 475.094 320.661 474.299 321.059C472.739 321.834 469.78 323.111 466.045 323.849C462.689 324.52 458.708 324.747 454.529 323.773C453.253 323.47 452.1 323.168 451.059 322.865C447.646 321.872 445.51 320.888 444.195 320.084C442.427 319.016 442.115 318.278 442.115 318.278C442.115 318.278 442.21 317.37 442.371 315.904C442.881 311.317 444.044 301.292 444.98 296.95C445.784 293.214 444.857 288.315 444.195 283.151C443.836 280.418 443.562 277.599 443.647 274.847C443.978 264.548 456.364 264.15 456.364 264.15C456.364 264.15 465.289 263.677 470.328 270.421C473.732 274.97 476.833 278.035 478.828 278.82C479.793 279.207 480.492 279.056 480.852 278.29C481.088 277.789 481.504 276.654 482.062 275.207C482.071 275.197 482.071 275.197 482.071 275.197C484.123 269.835 487.971 260.178 490.987 262.193C494.826 264.765 486.184 295.011 479.774 291.739Z",
    fill: "url(#paint55_linear_431_11178)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M463.559 311.052C463.559 311.052 466.774 310.541 468.305 309.823C469.837 309.104 471.369 307.42 471.369 307.42C471.369 307.42 470.641 310.286 469.336 311.742C468.031 313.199 467.653 313.35 467.653 313.35C467.653 313.35 468.362 310.901 467.01 311.09C465.667 311.289 463.559 311.052 463.559 311.052Z",
    fill: "url(#paint56_linear_431_11178)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M472.475 299.428C472.295 299.23 469.204 295.825 467.199 295.267C465.129 294.69 465.242 294.539 467.464 293.432C469.185 292.571 470.452 291.039 470.943 290.368C470.338 291.257 469.856 292.24 470.319 293.81C470.773 295.324 471.615 296.837 472.475 299.428Z",
    fill: "url(#paint57_linear_431_11178)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M453.367 305.916C450.549 308.3 447.694 311.09 446.417 313.558C445.462 315.403 445.387 317.067 446.862 318.278C447.42 318.732 447.949 319.224 448.441 319.734C449.471 320.784 450.36 321.91 451.05 322.865C447.637 321.872 445.5 320.888 444.186 320.084C442.418 319.015 442.106 318.278 442.106 318.278C442.106 318.278 442.2 317.37 442.361 315.904C442.872 311.317 444.035 301.291 444.971 296.95C445.774 293.214 444.848 288.315 444.186 283.151C444.186 283.151 451.305 288.069 449.386 290.358C447.467 292.647 446.086 297.139 447.996 298.501C449.925 299.863 458.274 301.783 453.367 305.916Z",
    fill: "url(#paint58_linear_431_11178)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M481.948 279.898C482.1 281.316 478.819 278.838 478.819 278.838V278.829C479.783 279.217 480.483 279.065 480.842 278.299C481.079 277.798 481.495 276.663 482.052 275.216C481.646 276.304 481.797 278.488 481.948 279.898Z",
    fill: "url(#paint59_linear_431_11178)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M466.046 323.868C466.046 323.868 456.354 326.771 450.927 325.617C447.902 324.984 445.916 326.26 444.715 327.537C444.668 327.339 444.612 327.13 444.564 326.922C443.846 323.934 444.186 320.084 444.186 320.084C445.5 320.888 447.637 321.872 451.05 322.865C452.09 323.168 453.234 323.47 454.52 323.773C458.699 324.757 462.689 324.53 466.046 323.868Z",
    fill: "url(#paint60_linear_431_11178)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M466.83 246.672C466.83 246.672 462.963 247.429 464.712 252.876C466.462 258.324 468.22 260.925 465.544 262.836C462.869 264.756 464.164 266.288 464.892 268.047C466.547 272.038 467.161 278.526 458.349 277.836C449.537 277.145 441.945 272.483 444.46 265.985C445.86 262.372 451.514 260.774 448.554 258.116C447.022 256.735 446.994 252.602 448.554 248.204C450.577 242.511 453.896 238.699 459.966 239.616C466.036 240.543 466.83 246.672 466.83 246.672Z",
    fill: "#012860"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M356.587 630.607C345.544 629.803 336.401 624.601 330.123 615.578C322.474 604.559 320.092 589.105 323.41 572.072C326.71 555.161 335.257 538.657 347.473 525.605C362.194 509.867 379.941 501.525 396.165 502.707C407.189 503.511 416.332 508.694 422.582 517.707C429.503 527.667 432.131 541.56 429.994 556.806C428.368 568.922 423.811 581.293 416.814 592.595C413.458 598.005 409.562 603.094 405.251 607.709C391.438 622.463 374.986 630.73 359.622 630.73C358.611 630.72 357.599 630.682 356.587 630.607ZM420.114 519.419C414.394 511.182 406.045 506.443 395.957 505.715C380.877 504.618 363.584 512.827 349.685 527.667C325.339 553.685 317.681 592.349 332.61 613.857C338.34 622.113 346.716 626.861 356.814 627.599C371.885 628.696 389.168 620.487 403.067 605.638C407.246 601.174 411.018 596.246 414.271 590.997C421.041 580.064 425.456 568.099 427.025 556.39C429.049 541.891 426.59 528.764 420.114 519.419L421.353 518.559L420.114 519.419Z",
    fill: "url(#paint61_linear_431_11178)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M343.332 602.592C347.88 609.137 354.517 612.911 362.516 613.488C363.253 613.545 363.991 613.564 364.719 613.564C375.563 613.564 387.174 607.87 396.997 597.684L394.86 596.369C385.065 606.338 373.143 611.795 362.695 611.038C355.462 610.509 349.459 607.104 345.355 601.193C338.879 591.867 338.321 578.04 342.746 564.43L340.618 563.134C335.787 577.652 336.354 592.539 343.332 602.592ZM390.899 523.429C398.132 523.959 404.126 527.355 408.22 533.256C411.813 538.42 413.685 545.211 413.685 552.825C413.685 555.085 413.515 557.421 413.184 559.814C412.446 565.262 410.867 570.785 408.513 576.139L410.631 577.406C413.146 571.76 414.838 565.915 415.614 560.155C417.155 549.117 415.254 539.073 410.243 531.857C405.705 525.321 399.087 521.566 391.088 520.98C379.364 520.119 366.515 526.163 355.869 537.541C354.413 539.101 353.032 540.719 351.737 542.393L353.855 543.66C355.046 542.137 356.323 540.652 357.656 539.224C367.054 529.189 378.608 523.363 388.97 523.363C389.604 523.354 390.256 523.382 390.899 523.429Z",
    fill: "url(#paint62_linear_431_11178)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M388.573 559.814C389.991 561.857 390.435 564.628 390.029 567.56C389.707 569.943 388.809 572.44 387.391 574.72C386.729 575.788 385.954 576.8 385.074 577.746C380.016 583.156 373.388 583.884 370.259 579.382C367.139 574.89 368.699 566.86 373.767 561.46C378.815 556.059 385.453 555.322 388.573 559.814Z",
    fill: "url(#paint63_linear_431_11178)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M376.736 559.341C377.53 560.486 377.785 562.046 377.549 563.682C377.369 565.026 376.858 566.416 376.064 567.702C375.696 568.298 375.261 568.875 374.76 569.405C371.923 572.441 368.198 572.847 366.449 570.322C364.7 567.797 365.579 563.304 368.415 560.268C371.261 557.232 374.986 556.826 376.736 559.341Z",
    fill: "url(#paint64_linear_431_11178)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M506.257 586.835C501.085 586.457 496.802 584.026 493.862 579.789C490.278 574.625 489.163 567.39 490.723 559.407C492.273 551.482 496.273 543.755 501.993 537.645C508.895 530.277 517.205 526.361 524.798 526.919C529.96 527.298 534.243 529.728 537.174 533.947C540.417 538.609 541.646 545.116 540.644 552.267C539.878 557.941 537.751 563.739 534.47 569.026C532.9 571.561 531.076 573.944 529.052 576.101C522.585 583.014 514.87 586.883 507.675 586.883C507.202 586.883 506.73 586.864 506.257 586.835ZM536.011 534.751C533.335 530.892 529.421 528.669 524.694 528.329C517.631 527.818 509.528 531.658 503.023 538.609C491.621 550.801 488.028 568.913 495.024 578.985C497.71 582.854 501.633 585.076 506.361 585.426C513.423 585.937 521.517 582.097 528.022 575.136C529.979 573.046 531.747 570.738 533.269 568.279C536.446 563.153 538.507 557.554 539.245 552.068C540.199 545.268 539.055 539.12 536.011 534.751L536.588 534.344L536.011 534.751Z",
    fill: "url(#paint65_linear_431_11178)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M500.045 573.708C502.172 576.772 505.283 578.541 509.027 578.815C509.367 578.843 509.717 578.853 510.057 578.853C515.135 578.853 520.571 576.186 525.176 571.41L524.173 570.795C519.588 575.467 514 578.021 509.102 577.671C505.718 577.425 502.9 575.826 500.981 573.055C497.946 568.686 497.681 562.207 499.761 555.832L498.768 555.227C496.509 562.027 496.783 568.998 500.045 573.708ZM522.33 536.623C525.714 536.869 528.523 538.458 530.442 541.229C532.125 543.651 533.004 546.828 533.004 550.394C533.004 551.453 532.928 552.55 532.768 553.666C532.427 556.22 531.68 558.802 530.584 561.318L531.576 561.914C532.758 559.266 533.543 556.532 533.912 553.837C534.64 548.673 533.742 543.963 531.397 540.577C529.269 537.522 526.168 535.753 522.424 535.479C516.931 535.072 510.918 537.91 505.926 543.234C505.245 543.963 504.592 544.719 503.987 545.504L504.98 546.1C505.538 545.381 506.134 544.691 506.758 544.019C511.164 539.319 516.572 536.595 521.422 536.595C521.725 536.595 522.027 536.604 522.33 536.623Z",
    fill: "url(#paint66_linear_431_11178)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M521.243 553.666C521.905 554.622 522.113 555.927 521.924 557.289C521.772 558.405 521.347 559.578 520.685 560.646C520.373 561.148 520.014 561.621 519.598 562.065C517.224 564.6 514.123 564.94 512.658 562.831C511.192 560.722 511.93 556.967 514.303 554.433C516.667 551.907 519.777 551.567 521.243 553.666Z",
    fill: "url(#paint67_linear_431_11178)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M515.693 553.449C516.061 553.988 516.184 554.716 516.08 555.482C515.995 556.107 515.759 556.759 515.39 557.364C515.22 557.648 515.012 557.913 514.785 558.159C513.452 559.578 511.712 559.776 510.89 558.594C510.067 557.412 510.483 555.303 511.807 553.884C513.13 552.465 514.879 552.267 515.693 553.449Z",
    fill: "url(#paint68_linear_431_11178)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M574.426 535.413C571.183 535.176 568.488 533.644 566.644 530.996C564.394 527.752 563.694 523.212 564.668 518.199C565.642 513.225 568.148 508.373 571.741 504.533C576.071 499.908 581.29 497.449 586.055 497.799C589.298 498.035 591.983 499.558 593.827 502.206C595.86 505.138 596.635 509.224 596.011 513.707C595.529 517.273 594.196 520.904 592.135 524.234C591.151 525.823 589.998 527.317 588.731 528.679C584.675 533.02 579.834 535.451 575.314 535.451C575.021 535.441 574.719 535.432 574.426 535.413ZM593.108 502.717C591.425 500.296 588.967 498.905 586.008 498.688C581.574 498.366 576.487 500.778 572.402 505.147C565.245 512.799 562.995 524.167 567.382 530.485C569.065 532.916 571.533 534.306 574.501 534.524C578.936 534.845 584.013 532.434 588.097 528.064C589.327 526.749 590.433 525.302 591.388 523.761C593.383 520.545 594.678 517.027 595.141 513.584C595.727 509.318 595.009 505.46 593.108 502.717L593.477 502.461L593.108 502.717Z",
    fill: "url(#paint69_linear_431_11178)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M570.53 527.175C571.864 529.095 573.821 530.211 576.175 530.381C576.392 530.4 576.61 530.4 576.827 530.4C580.014 530.4 583.427 528.726 586.32 525.728L585.686 525.34C582.803 528.272 579.295 529.88 576.232 529.653C574.104 529.501 572.336 528.499 571.136 526.759C569.226 524.016 569.065 519.949 570.37 515.948L569.746 515.57C568.309 519.836 568.479 524.215 570.53 527.175ZM584.514 503.89C586.641 504.041 588.4 505.043 589.61 506.774C590.669 508.297 591.217 510.293 591.217 512.525C591.217 513.187 591.17 513.877 591.066 514.577C590.849 516.185 590.385 517.802 589.695 519.382L590.319 519.75C591.057 518.086 591.558 516.374 591.785 514.681C592.239 511.437 591.681 508.477 590.206 506.358C588.873 504.438 586.925 503.331 584.571 503.161C581.12 502.906 577.347 504.684 574.218 508.032C573.792 508.486 573.386 508.968 572.998 509.46L573.622 509.829C573.972 509.385 574.35 508.94 574.738 508.524C577.499 505.573 580.902 503.861 583.947 503.861C584.136 503.871 584.325 503.88 584.514 503.89Z",
    fill: "url(#paint70_linear_431_11178)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M583.833 514.596C584.249 515.201 584.381 516.015 584.258 516.875C584.164 517.575 583.899 518.313 583.483 518.984C583.285 519.296 583.058 519.599 582.802 519.873C581.318 521.462 579.361 521.68 578.444 520.356C577.527 519.032 577.99 516.677 579.474 515.088C580.959 513.489 582.916 513.272 583.833 514.596Z",
    fill: "url(#paint71_linear_431_11178)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M580.354 514.454C580.59 514.795 580.666 515.248 580.59 515.731C580.534 516.128 580.392 516.535 580.155 516.913C580.042 517.093 579.919 517.254 579.777 517.414C578.945 518.303 577.848 518.426 577.338 517.689C576.827 516.951 577.083 515.627 577.915 514.728C578.737 513.83 579.834 513.716 580.354 514.454Z",
    fill: "url(#paint72_linear_431_11178)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M143.514 436.767L118.289 422.192L67.564 451.19L93.0541 465.916L143.514 436.767Z",
    fill: "url(#paint73_linear_431_11178)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M160.344 446.48L186.902 461.821L101.459 509.63L76.2246 495.056L160.344 446.48Z",
    fill: "url(#paint74_linear_431_11178)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M101.46 412.479L67.5642 431.763L42.5752 417.331L76.2248 397.904L101.46 412.479Z",
    fill: "url(#paint75_linear_431_11178)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M258.749 585.417V604.323C258.749 606.707 258.409 609.033 257.756 611.303C252.254 630.333 224.646 644.794 191.45 644.794C158.245 644.794 130.656 630.333 125.153 611.303C124.501 609.043 124.16 606.707 124.16 604.323V585.417C124.16 588.67 124.794 591.829 126.004 594.865C126.968 597.286 128.292 599.622 129.946 601.855C140.432 616.023 164.022 625.887 191.45 625.887C218.878 625.887 242.487 616.013 252.963 601.845C254.608 599.623 255.932 597.286 256.896 594.865C258.116 591.829 258.749 588.67 258.749 585.417Z",
    fill: "#C7DAFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M258.749 585.417C258.749 588.67 258.125 591.839 256.896 594.875C256.055 596.993 254.93 599.036 253.568 601.013C246.496 611.19 232.701 619.267 215.522 623.23C208.053 624.951 199.931 625.897 191.45 625.897C171.179 625.897 153.007 620.506 140.669 611.965C133.681 607.132 128.576 601.306 126.014 594.875C124.803 591.839 124.17 588.67 124.17 585.417C124.17 578.9 126.723 572.743 131.289 567.295C142.342 554.045 165.138 544.956 191.46 544.956C208.686 544.956 224.41 548.852 236.323 555.255C250.079 562.661 258.749 573.424 258.749 585.417Z",
    fill: "url(#paint76_linear_431_11178)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M236.303 555.246L189.852 582.787L140.659 611.956C133.672 607.123 128.566 601.297 126.004 594.865C124.794 591.829 124.16 588.661 124.16 585.407C124.16 578.891 126.713 572.734 131.28 567.286C142.332 554.035 165.128 544.946 191.45 544.946C208.676 544.946 224.4 548.843 236.303 555.246Z",
    fill: "#F22AFF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M258.749 585.417C258.749 588.67 258.125 591.839 256.896 594.875C256.054 596.993 254.929 599.036 253.568 601.013L189.852 582.797L236.303 555.255C250.079 562.661 258.749 573.424 258.749 585.417Z",
    fill: "url(#paint77_linear_431_11178)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M236.304 555.246L189.852 582.787L131.271 567.286C142.323 554.035 165.119 544.946 191.441 544.946C208.677 544.946 224.4 548.843 236.304 555.246Z",
    fill: "#51A0FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M253.559 601.013C246.486 611.19 232.692 619.267 215.513 623.229L189.843 582.797L253.559 601.013Z",
    fill: "#913BFF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M111.728 347.503C111.728 347.503 112.796 438.252 113.278 523.505C113.278 523.505 114.375 386.186 114.829 347.503H111.728Z",
    fill: "url(#paint78_linear_431_11178)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M113.278 349.896C119.612 349.896 124.746 344.759 124.746 338.423C124.746 332.087 119.612 326.951 113.278 326.951C106.944 326.951 101.809 332.087 101.809 338.423C101.809 344.759 106.944 349.896 113.278 349.896Z",
    fill: "url(#paint79_linear_431_11178)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M405.667 122.896C405.667 122.896 406.735 213.645 407.218 298.899C407.218 298.899 408.314 161.579 408.768 122.896H405.667Z",
    fill: "url(#paint80_linear_431_11178)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M407.218 125.289C413.552 125.289 418.686 120.153 418.686 113.817C418.686 107.481 413.552 102.344 407.218 102.344C400.884 102.344 395.749 107.481 395.749 113.817C395.749 120.153 400.884 125.289 407.218 125.289Z",
    fill: "url(#paint81_linear_431_11178)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M630.436 342.736C630.436 342.736 631.504 433.485 631.986 518.738C631.986 518.738 633.083 381.419 633.537 342.736H630.436Z",
    fill: "url(#paint82_linear_431_11178)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M631.977 345.129C638.311 345.129 643.446 339.993 643.446 333.657C643.446 327.32 638.311 322.184 631.977 322.184C625.643 322.184 620.508 327.32 620.508 333.657C620.508 339.993 625.643 345.129 631.977 345.129Z",
    fill: "url(#paint83_linear_431_11178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_431_11178",
    x1: 140.099,
    y1: 462.461,
    x2: 332.506,
    y2: 462.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_431_11178",
    x1: 363.135,
    y1: 333.545,
    x2: 660.683,
    y2: 333.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_431_11178",
    x1: 171.582,
    y1: 316.639,
    x2: 371.601,
    y2: 316.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_431_11178",
    x1: 53.0632,
    y1: 165.685,
    x2: 243.037,
    y2: 165.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_431_11178",
    x1: 237.694,
    y1: 125.502,
    x2: 286.377,
    y2: 125.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_431_11178",
    x1: 113.274,
    y1: 206.837,
    x2: 258.208,
    y2: 206.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_431_11178",
    x1: 83.1396,
    y1: 280.95,
    x2: 131.479,
    y2: 280.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_431_11178",
    x1: 83.161,
    y1: 303.265,
    x2: 146.315,
    y2: 303.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AAEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_431_11178",
    x1: 123.743,
    y1: 184.055,
    x2: 224.544,
    y2: 184.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_431_11178",
    x1: 119.563,
    y1: 229.998,
    x2: 130.069,
    y2: 229.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_431_11178",
    x1: 137.544,
    y1: 170.246,
    x2: 148.05,
    y2: 170.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_431_11178",
    x1: 173.441,
    y1: 220.43,
    x2: 183.948,
    y2: 220.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_431_11178",
    x1: 191.452,
    y1: 138.882,
    x2: 201.959,
    y2: 138.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_431_11178",
    x1: 218.218,
    y1: 154.445,
    x2: 228.724,
    y2: 154.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_431_11178",
    x1: 25.2512,
    y1: 136.998,
    x2: 43.1997,
    y2: 136.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_431_11178",
    x1: 0.593661,
    y1: 158.598,
    x2: 44.2722,
    y2: 158.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_431_11178",
    x1: 0.593655,
    y1: 168.737,
    x2: 44.2724,
    y2: 168.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_431_11178",
    x1: 310.697,
    y1: 158.598,
    x2: 328.646,
    y2: 158.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_431_11178",
    x1: 311.507,
    y1: 164.812,
    x2: 355.187,
    y2: 164.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_431_11178",
    x1: 311.507,
    y1: 174.951,
    x2: 355.187,
    y2: 174.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_431_11178",
    x1: 244.142,
    y1: 78.406,
    x2: 272.275,
    y2: 78.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_431_11178",
    x1: 138.087,
    y1: 315.456,
    x2: 166.22,
    y2: 315.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_431_11178",
    x1: 59.645,
    y1: 196.001,
    x2: 87.778,
    y2: 196.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_431_11178",
    x1: 247.969,
    y1: 246.841,
    x2: 276.102,
    y2: 246.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_431_11178",
    x1: 141.633,
    y1: 78.406,
    x2: 169.766,
    y2: 78.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00248397,
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4905,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8082,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_431_11178",
    x1: 480.15,
    y1: 145.576,
    x2: 710.192,
    y2: 145.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_431_11178",
    x1: 639.551,
    y1: 163.841,
    x2: 678.597,
    y2: 163.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_431_11178",
    x1: 612.585,
    y1: 203.61,
    x2: 639.551,
    y2: 203.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_431_11178",
    x1: 600.259,
    y1: 160.469,
    x2: 639.551,
    y2: 160.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_431_11178",
    x1: 612.537,
    y1: 158.324,
    x2: 639.551,
    y2: 158.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_431_11178",
    x1: 601.102,
    y1: 189.223,
    x2: 639.551,
    y2: 189.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_431_11178",
    x1: 497.938,
    y1: 71.8772,
    x2: 580.107,
    y2: 71.8772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_431_11178",
    x1: 497.918,
    y1: 136.636,
    x2: 580.086,
    y2: 136.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_431_11178",
    x1: 517.675,
    y1: 119.631,
    x2: 560.35,
    y2: 119.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_431_11178",
    x1: 507.403,
    y1: 131.504,
    x2: 570.633,
    y2: 131.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_431_11178",
    x1: 507.393,
    y1: 143.353,
    x2: 570.633,
    y2: 143.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_431_11178",
    x1: 506.014,
    y1: 154.83,
    x2: 570.633,
    y2: 154.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_431_11178",
    x1: 274.858,
    y1: 337.615,
    x2: 278.376,
    y2: 337.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_431_11178",
    x1: 289.418,
    y1: 382.86,
    x2: 308.553,
    y2: 382.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5466,
    stopColor: "#DAEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#D4E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_431_11178",
    x1: 274.229,
    y1: 292.198,
    x2: 283.489,
    y2: 292.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_431_11178",
    x1: 272.762,
    y1: 310.683,
    x2: 280.973,
    y2: 310.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_431_11178",
    x1: 284.128,
    y1: 292.253,
    x2: 292.028,
    y2: 292.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_431_11178",
    x1: 276.376,
    y1: 282.344,
    x2: 290.534,
    y2: 282.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_431_11178",
    x1: 276.844,
    y1: 324.153,
    x2: 308.577,
    y2: 324.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_431_11178",
    x1: 281.811,
    y1: 303.143,
    x2: 273.798,
    y2: 323.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_431_11178",
    x1: 300.802,
    y1: 308.264,
    x2: 307.457,
    y2: 308.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_431_11178",
    x1: 292.724,
    y1: 328.471,
    x2: 308.576,
    y2: 328.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0862,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_431_11178",
    x1: 465.823,
    y1: 407.131,
    x2: 483.357,
    y2: 407.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_431_11178",
    x1: 453.462,
    y1: 404.147,
    x2: 470.826,
    y2: 404.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_431_11178",
    x1: 460.424,
    y1: 375.219,
    x2: 471.222,
    y2: 375.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_431_11178",
    x1: 448.396,
    y1: 372.973,
    x2: 459.09,
    y2: 372.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_431_11178",
    x1: 443.873,
    y1: 334.783,
    x2: 477.28,
    y2: 334.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_431_11178",
    x1: 437.798,
    y1: 284.121,
    x2: 453.371,
    y2: 284.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_431_11178",
    x1: 455.862,
    y1: 251.267,
    x2: 470.323,
    y2: 251.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_431_11178",
    x1: 489.065,
    y1: 259.643,
    x2: 496.496,
    y2: 259.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_431_11178",
    x1: 442.108,
    y1: 293.183,
    x2: 491.929,
    y2: 293.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_431_11178",
    x1: 463.562,
    y1: 310.39,
    x2: 471.377,
    y2: 310.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_431_11178",
    x1: 465.723,
    y1: 294.898,
    x2: 472.474,
    y2: 294.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00126202,
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_431_11178",
    x1: 442.108,
    y1: 303.013,
    x2: 454.89,
    y2: 303.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00126202,
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_431_11178",
    x1: 478.824,
    y1: 277.779,
    x2: 482.055,
    y2: 277.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_431_11178",
    x1: 444.104,
    y1: 323.811,
    x2: 466.044,
    y2: 323.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C00E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F22AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_431_11178",
    x1: 430.727,
    y1: 566.656,
    x2: 321.953,
    y2: 566.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_431_11178",
    x1: 416.128,
    y1: 567.237,
    x2: 337.458,
    y2: 567.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5101,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9988,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_431_11178",
    x1: 390.174,
    y1: 569.604,
    x2: 368.652,
    y2: 569.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_431_11178",
    x1: 377.637,
    y1: 564.833,
    x2: 365.564,
    y2: 564.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_431_11178",
    x1: 540.988,
    y1: 556.874,
    x2: 490.033,
    y2: 556.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_431_11178",
    x1: 534.148,
    y1: 557.146,
    x2: 497.296,
    y2: 557.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_431_11178",
    x1: 521.991,
    y1: 558.256,
    x2: 511.909,
    y2: 558.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_431_11178",
    x1: 516.118,
    y1: 556.02,
    x2: 510.462,
    y2: 556.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_431_11178",
    x1: 596.226,
    y1: 516.605,
    x2: 564.241,
    y2: 516.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_431_11178",
    x1: 591.933,
    y1: 516.775,
    x2: 568.801,
    y2: 516.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    stopColor: "#9DC4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5107,
    stopColor: "#B7D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_431_11178",
    x1: 584.301,
    y1: 517.472,
    x2: 577.973,
    y2: 517.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_431_11178",
    x1: 580.615,
    y1: 516.068,
    x2: 577.065,
    y2: 516.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_431_11178",
    x1: 67.5663,
    y1: 444.053,
    x2: 143.519,
    y2: 444.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_431_11178",
    x1: 76.2208,
    y1: 478.056,
    x2: 186.898,
    y2: 478.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_431_11178",
    x1: 42.5787,
    y1: 414.834,
    x2: 101.462,
    y2: 414.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_431_11178",
    x1: 124.154,
    y1: 585.419,
    x2: 258.748,
    y2: 585.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_431_11178",
    x1: 189.851,
    y1: 578.131,
    x2: 258.747,
    y2: 578.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_431_11178",
    x1: 111.725,
    y1: 435.503,
    x2: 114.823,
    y2: 435.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_431_11178",
    x1: 124.738,
    y1: 338.426,
    x2: 101.81,
    y2: 338.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_431_11178",
    x1: 405.664,
    y1: 210.894,
    x2: 408.762,
    y2: 210.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_431_11178",
    x1: 418.677,
    y1: 113.817,
    x2: 395.749,
    y2: 113.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_431_11178",
    x1: 630.432,
    y1: 430.735,
    x2: 633.53,
    y2: 430.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_431_11178",
    x1: 643.446,
    y1: 333.659,
    x2: 620.517,
    y2: 333.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls14);
export default __webpack_public_path__ + "static/media/ils_14.5f0a59090f857c3d77591830fb3a717f.svg";
export { ForwardRef as ReactComponent };